import React from "react";
import { storyblokEditable } from "@storyblok/react";
import { PricingPanelModel } from "./PricingPanelModel";

import "./PricingPanel.css";

const PricingPanel: React.FC<{ blok: PricingPanelModel }> = ({ blok }) => {
  return (
    <div {...storyblokEditable(blok)} className={`pricing-panel`}>
      <div className="pricing-panel-container">
        <div className="title">
          <span>{blok.title} Title</span>
        </div>
        <div className="product-plan">product-plan</div>
        <div className="pricing-panel-content">
          <div className="pricing-panel-item">1</div>
          <div className="pricing-panel-item">2</div>
          <div className="pricing-panel-item">3</div>
        </div>
        <div className="pricing-panel-footer">link</div>
      </div>
    </div>
  );
};

export default PricingPanel;
